import React from 'react'

const Question = () => {
  return (
    <main id="main" className="main">
    <div><h1>Question</h1></div>
    </main>
  )
}

export default Question